import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import error404Component from './error404.component';

let error404Module = angular.module('error404', [
  uiRouter
])

  .config(($stateProvider) => {
    "ngInject";

    $stateProvider
      .state('site.error404', {
        url: '/error404',
        component: 'error404'
      });
  })

  .component('error404', error404Component)

  .name;

export default error404Module;



// WEBPACK FOOTER //
// ./client/app/modules/site/error404/error404.js